import { useNavigate, useParams } from "react-router-dom";
import TextField from "../../components/UI/TextField";
import { ToastContainer } from "react-toastify";
import { useAuthStore } from "../../store/authStore";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getIssueDetails } from "../../api/issuesApi";
import TextArea from "../../components/UI/TextArea";
import ShowDetailsLabel from "../../components/UI/showDetailsLabel";
import { capitalize } from "../../helpers/commonFunction";
import moment from "moment";

const IssueDetails = () => {
    const navigate = useNavigate();
    const { token, setLoaderState } = useAuthStore((state) => state);
    const { issueId } = useParams();
    const [issueDetails, setIssueDetails] = useState([])
    const { data, isLoading } = useQuery([issueId, token], () => getIssueDetails(issueId, token))

    useEffect(() => {
        if (data?.data?.data) {
            setIssueDetails(data?.data?.data[0])
        }
    }, [data])

    useEffect(() => {
        if (isLoading) {
            setLoaderState(true)
        } else {
            setLoaderState(false)
        }
    }, [isLoading])

    return (
        <>
            <div className="p-4">
                <ToastContainer />
                <div className="flex justify-between items-center">
                    <h1 className="text-4xl w-full h-full">Issue Details</h1>
                    <div className="flex">
                        <button
                            onClick={() => navigate("/layout/issues")}
                            className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl"
                        >
                            View Issues
                        </button>
                    </div>
                </div>
                <br />
                <hr />
            </div>
            <form
                // onSubmit={handleSubmit(submitDrone)}
                className="grid grid-cols-2 gap-2 mt-10 leading-10"
            >
                <ShowDetailsLabel
                    value={issueDetails?.droneId?.droneName && capitalize(issueDetails?.droneId?.droneName) || ""}
                    label="Drone Name"
                />
                <ShowDetailsLabel
                    value={issueDetails?.issue && capitalize(issueDetails?.issue) || ""}
                    label="Issue"
                />
                <ShowDetailsLabel
                    value={issueDetails?.createdAt && moment(issueDetails?.createdAt).format("DD/MM/YYYY hh:mm A") || ""}
                    label="Issue Created On"
                />
                <ShowDetailsLabel
                    value={issueDetails?.droneRecoverTime && moment(issueDetails?.droneRecoverTime).format('DD/MM/YYYY hh:mm A') || ""}
                    label="Drone Recover Time"
                />
                <ShowDetailsLabel
                    value={issueDetails?.incidentDiscoverTime && moment(issueDetails?.incidentDiscoverTime).format("DD/MM/YYYY hh:mm A") || ""}
                    label="Incident Discover Time"
                />
                <ShowDetailsLabel
                    value={issueDetails?.issueDescription && capitalize(issueDetails?.issueDescription) || ""}
                    label="Issue Description"
                />
            </form>
        </>)
}
export default IssueDetails;